import { NavLink } from "react-router";
import {
    Sidebar,
    SidebarContent,
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar";
import React from "react";
import AccessGuard from "@/components/access-guard";

export const SearchSidebar = ({
    ref,
    ...props
}: React.ComponentProps<"div"> & {
    side?: "left" | "right";
    variant?: "sidebar" | "floating" | "inset";
    collapsible?: "offcanvas" | "icon" | "none";
}) => {
    return (
        <Sidebar {...props} ref={ref}>
            {props.children}
            <SidebarContent>
                <SidebarGroup>
                    <SidebarGroupLabel>Search</SidebarGroupLabel>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            <SidebarMenuItem>
                                <SidebarMenuButton asChild>
                                    <NavLink
                                        className={"text-default-color"}
                                        to={`/search/devices`}
                                    >
                                        <span>Search devices</span>
                                    </NavLink>
                                </SidebarMenuButton>
                            </SidebarMenuItem>
                            <AccessGuard
                                permissions={["charge_transactions_read"]}
                                unauthorizedBehaviour={"hide"}
                            >
                                <SidebarMenuItem>
                                    <SidebarMenuButton asChild>
                                        <NavLink
                                            className={"text-default-color"}
                                            to={`/search/sessions`}
                                            end
                                        >
                                            <span>Search sessions</span>
                                        </NavLink>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            </AccessGuard>
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarContent>
        </Sidebar>
    );
};
